export default "__VITE_ASSET__Bq5c825x__"